import React from 'react'
import Layout from '../component/Layout/Layout'

const StripePaymentFailed = () => {
  return (
    <Layout
    title="My Orders : Chaashni by Maansi & Ketan"
    description="Chaashni by Maansi & Ketan: Description"
  >
    <div className="site-content-wrap my-account">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h1 className="sustom-heading-h1">Order<span> Status</span></h1>
            <h4 className='text-center text-danger'>Payment Failed!</h4>
          </div>
        </div>
      </div>
    </div>
  </Layout>
  )
}

export default StripePaymentFailed
